import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';
import moment from 'moment';

import { AppPrivacyNoticeDialogComponent } from '../../../app/shared/components/privacy-notice-dialog/privacy-notice-dialog.component';

@Component({
  selector: 'mps-app-footer',
  templateUrl: './mps-footer.component.html',
  styleUrls: ['./mps-footer.component.scss'],
  imports: [TranslateModule],
})
export class MpsFooterComponent {
  private readonly _dialog = inject(MatDialog);

  currentYear = moment().format('Y');

  openPrivacyNotice(): void {
    this._dialog.open(AppPrivacyNoticeDialogComponent, {
      width: '640px',
      minWidth: '280px',
      maxWidth: '90vw',
    });
  }
}
